import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetRisk = (riskId) => axios.get(`${apiPaths.risksBase}/${riskId}`);

const onGetRiskHistory = (riskId) => axios.get(`${apiPaths.risksBase}/${riskId}/history`);

const onGetRiskOrganizations = (riskId) => axios.get(`${apiPaths.risksBase}/${riskId}/organizations`);

const onCreateRisk = (risk) => axios.post(apiPaths.risksBase, risk);
const onUpdateRisk = (risk) => axios.put(apiPaths.risksBase, risk);
const onDeleteRisk = (riskId) => axios.post(`${apiPaths.risksBase}/delete-many`, riskId);

export { onGetRisk, onGetRiskHistory, onGetRiskOrganizations, onCreateRisk, onUpdateRisk, onDeleteRisk };
